import { Center } from "@chakra-ui/layout"
import { observer } from "mobx-react"
import { useRouter } from "next/router"
import React, { useEffect, useMemo, useState } from "react"

import Icon from "~/components/atoms/Icon"
import { Container } from "~/components/layouts/Container"
import Header from "~/components/organisms/Header"
import { Color } from "~/consts/style-mixins"
import { internalLink } from "~/services/helper"
import { useStores } from "~/stores/StoreProvider"

import { HeaderForAuthRegister } from "../AuthRegisterPage/components/HeaderForAuthRegister"
import { useAuthRegisterRouterQuery } from "../AuthRegisterPage/useAuthRegisterRouterQuery"
import { AuthRegisterCompleteJobHunting } from "./AuthRegisterCompleteJobHunting"
import { AuthRegisterCompleteLongInternship } from "./AuthRegisterCompleteLongInternship"
import * as Styled from "./styled"

const AuthRegisterCompleteAdditionallyPage: React.FC = () => {
  const { userStore, profileStore } = useStores()
  const router = useRouter()
  const { redirect_after_auth, openModal: open_modal, auto_redirect } = useAuthRegisterRouterQuery()
  const redirectAfterAuth = useMemo(() => (redirect_after_auth || "") as string, [router])
  const openModal = useMemo(() => (open_modal || "") as string, [router])
  const redirectPath = openModal === "" ? redirectAfterAuth : `${redirectAfterAuth}?openModal=${openModal}`

  const [isLoggedIn, setIsLoggedIn] = useState<boolean>()

  // redirectPath への自動リダイレクト処理
  if (auto_redirect === "true" && redirectPath) {
    setTimeout(() => {
      router.replace(redirectPath)
    }, 3000)
  }

  // プロフィールがAPIから取得されたら profileStore.applicationCategories の値を取得・判定する
  const isDisplayJobHunting = useMemo(() => {
    if (profileStore.json === undefined) return
    const ids = profileStore.applicationCategories.map(({ id }) => id)
    return ids.toString() === "3"
  }, [profileStore.json])

  // アカウント情報がAPIから取得されたら userStore.authed でログイン情報を取得する
  useEffect(() => {
    if (!userStore.requestedFetchGetMe) return
    setIsLoggedIn(userStore.authed)
  }, [userStore.requestedFetchGetMe])

  // ログイン情報取得完了前の場合ローディング
  if (isLoggedIn === undefined) {
    return <LoadingPage />
  }

  // ログアウト中のアクセスをブロック
  if (isLoggedIn === false) {
    router.replace(internalLink("/auth/register"))
    return <LoadingPage />
  }

  return (
    <>
      <Header showTab logoType="Plain" showFlowLink={false} />
      <Styled.Wrapper>
        <Container size="Medium">
          <Styled.Label>
            <Styled.Title type="SubHero">追加情報の入力が完了しました</Styled.Title>
            {auto_redirect === "true" && redirectPath && (
              <Styled.AutoRedirect>
                <span className="bold">3秒後に自動的に元の画面にリダイレクトされます</span>
                <br />
                （切り替わらない場合は下記のボタンをクリックしてください）
              </Styled.AutoRedirect>
            )}
            {redirectPath && (
              <Styled.SecondaryLink
                href={redirectPath}
                size="Large"
                icon="Next"
                isButton
                className="gtm_back-button-after-register"
              >
                登録前に見ていた画面に戻る
              </Styled.SecondaryLink>
            )}
          </Styled.Label>

          {isDisplayJobHunting === undefined && <LoadingContent />}
          {isDisplayJobHunting !== undefined && isDisplayJobHunting === true && <AuthRegisterCompleteJobHunting />}
          {isDisplayJobHunting !== undefined && isDisplayJobHunting === false && <AuthRegisterCompleteLongInternship />}
        </Container>
      </Styled.Wrapper>
    </>
  )
}

const LoadingPage = () => (
  <>
    <HeaderForAuthRegister />
    <LoadingContent />
  </>
)

const LoadingContent = () => (
  <Center p={60}>
    <Icon type="Loading" size={16} color={Color.Primary} className="isLoading" />
  </Center>
)

export default observer(AuthRegisterCompleteAdditionallyPage)
